import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, message, Space, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import {
  apiDeleteLinkOrgService,
  apiOrganizationServiceList,
} from "../../../api/api";
import { ModalNewLink } from "./modalForms/addLinkOrgService";
import "./index.css";
import { addLinkOrgServiceModal, currentEditOrgService } from "./state";
import { CompanyServiceMatchType } from "../../../types";
import { EditRowButton } from "../../base/button";
import { ModalEditLink } from "./modalForms/editLinkOrgService";

export const AdminPanel = () => {
  const [dataSource, setDataSource] = useState<CompanyServiceMatchType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const setVisible = useSetRecoilState(addLinkOrgServiceModal);

  const getOrganizationServiceList = async () => {
    setLoading(true);
    const resp = await apiOrganizationServiceList();
    setDataSource(resp.result);
    setLoading(false);
  };

  const columnsTableCompanyServiceMatching: ColumnsType<CompanyServiceMatchType> =
    [
      {
        title: "ИНН",
        dataIndex: "inn",
      },
      {
        title: "Название организации",
        dataIndex: "companyName",
      },
      {
        title: "Идентификатор услуги",
        dataIndex: "serviceId",
      },
      {
        title: "Название услуги",
        dataIndex: "serviceName",
      },
      {
        title: "Действия",
        render: (row: CompanyServiceMatchType) => (
          <>
            <Space>
              <EditRowButton row={row} recoilState={currentEditOrgService} />
              <Button
                icon={<DeleteOutlined />}
                onClick={() => {
                  apiDeleteLinkOrgService(row.serviceId).then(() => {
                    setDataSource(
                      dataSource.filter((el) => el.serviceId !== row.serviceId)
                    );
                    message.success("Услуга удалена");
                  });
                }}
              />
            </Space>
          </>
        ),
      },
    ];

  useEffect(() => {
    getOrganizationServiceList();
  }, []);

  return (
    <>
      <h1 style={{ float: "left", margin: "10px 20px 0px" }}>
        Сопоставления организаций и услуг
      </h1>
      <Button
        icon={<PlusOutlined />}
        type="primary"
        style={{ marginTop: 10, marginRight: 20, float: "right" }}
        onClick={() => setVisible(true)}
      >
        Добавить связь
      </Button>
      <div style={{ clear: "both" }} />
      <Table
        style={{ margin: 20, marginTop: 10 }}
        loading={loading}
        scroll={{ y: "calc(100vh - 244px" }}
        columns={columnsTableCompanyServiceMatching}
        dataSource={dataSource}
      />
      <ModalNewLink
        modalState={addLinkOrgServiceModal}
        updateDataSource={setDataSource}
      />
      <ModalEditLink
        modalState={currentEditOrgService}
        updateDataSource={setDataSource}
      />
    </>
  );
};
